<div class='map-placeholder background-animate'>
</div>

<style>
   .map-placeholder {
       width: 100%;
       height: 500px;
       line-height: 100%;
       text-align: center;
       color: white;
   }

</style>